export const PERMISSIONS_SET_PERMISSIONS = "permission/get-permission";
